<template>
  <Popover placement="bottom" :width="350">
    <div title="Filter Tags" class="drop-down-button" style="margin-right: 5px">
        <i class="fal fa-tag"></i>
    </div>
    <div slot="content" class="tag-filters">
      <div class="filter-tools-fixed">
          <div class="drop-down-filter-header">
            <h3 class="filter-header">Filter Tags</h3>
            <span class="filter-select-all-text" v-on:click="selectAll()">{{selectAllText}}</span>
            <div style="clear: both;"></div>
          </div>
          <Search v-on:searcher="onSearch" :placeholder="'Search tags'"/>
      </div>
      <div class="filter-content">
        <div v-for="tag in searchedList" v-bind:key="tag.tag_id" class="list-item" @click="tag.filteredIn = !tag.filteredIn; tagFilterChanged(tag);">
          <span class="list-item-title">
            <span class="tag" :style="{ background: '#'+ tag.colour, color: utils.getContrastYIQ(tag.colour)}">
              {{tag.label}}
            </span>
          </span>
          <input class="filter-checkbox" type="checkbox" name="tag" :id="'tag' + tag.tag_id" @change="tagFilterChanged(tag)" v-model="tag.filteredIn">
        </div> 
        <div v-if="searchedList.length === 0" style="text-align: center">
          There are no tags in this learning path.
        </div>
      </div>
    </div>
  </Popover>
</template>

<script>
  const _ = require('lodash');
  import Vue from 'vue';
  
  import utils from '@/utils/utils.js';

  import Popover from '../popover'
  import Search from '../Search';
  
  export default {
    name: 'TagsFilter',
    components: {
      Popover,
      Search
    },
    data: function () {
      var t = this;

      return {
       utils: utils,
       error: '',
       search: '',
       selectAllText: 'Deselect all'
      }
    },
    props: [
      'tags', 'tagFiltersApplied', 'popupOptions'
    ],
    mounted: function () {
    },
    computed: {
      searchedList() {
        var t = this;

        return _.filter(this.tags, function(tag) {
          return tag.label.toLowerCase().includes(t.search.toLowerCase())
        })
      }
    },    
    methods: {
      onSearch: function(val) {
        this.search = val;
      },
      calculateFilterButtonText: function (list) {
        var allFilteredIn = false;
        if (list.length !== undefined)
          allFilteredIn = _.countBy(list, 'filteredIn')['true'] === list.length;
        else
          allFilteredIn = _.countBy(list, 'filteredIn')['true'] === Object.keys(list).length;
        return allFilteredIn ? "Deselect all" : "Reset filters";
      },
      selectAll: function () {
        var t = this;

        if (t.selectAllText === "Deselect all") {
          _.each(t.tags, function(tag, key) {
            Vue.set(tag, 'filteredIn', false);
          });
        } else {
          _.each(t.tags, function(tag) {
            Vue.set(tag, 'filteredIn', true);
          });
        }

        t.selectAllText = t.calculateFilterButtonText(t.tags);
        t.tagFiltersApplied();
      },
      tagFilterChanged: function(type) {
        var t = this;
        t.selectAllText = t.calculateFilterButtonText(t.tags);
        t.tagFiltersApplied();
      }
    }
  }
</script>

<style lang="scss" scoped>
.tag-filters {
  .list-item-title {
    width: calc(100% - 55px);
  }

  .tag {
    padding: 15px;
    margin: 2px 10px;
    border-radius: 3px;
    cursor: pointer;
  }
}

@media only screen and (max-width: 600px) {
  .tag-filters {
    .book-title {
      max-width: calc(100vw - 35px);
    }
  }
}
</style>